import React from 'react';

const ArtistMenu = ({ onClose }) => {
  return (
    <div className='menu-wrapper'>
      <h3 className='menu-text'>
        If you would like to <strong>create art</strong> for Fund Raisin
        fundraisers (and receive payments every time your art is used), please
        get in touch with us via a{' '}
        <a
          href='https://x.com/fundraisinapp'
          target='_blank'
          className='menu-link'
        >
          <strong>X</strong>
        </a>{' '}
        or on the <strong>Arena</strong> at{' '}
        <a
          href='https://arena.social/fundraisinapp'
          target='_blank'
          className='menu-link'
        >
          <strong>@FundRaisinApp</strong>
        </a>
        . You can also join us on <strong>Instagram</strong> at{' '}
        <a
          href='https://instagram.com/fundraisin.app'
          target='_blank'
          className='menu-link'
        >
          <strong>@fundraisin.app</strong>
        </a>
        . We will help you get it up and running!
      </h3>
      <button className='menu-btn' onClick={onClose}>
        OK
      </button>
    </div>
  );
};

export default ArtistMenu;
